import { render } from "./SignUp.vue?vue&type=template&id=2cf315a6&scoped=true"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"

import "./SignUp.vue?vue&type=style&index=0&id=2cf315a6&scoped=true&lang=css"

import exportComponent from "/home/frog/Documents/vue/FEVO/fevo_site/fevo_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf315a6"]])

export default __exports__